var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"neg",attrs:{"id":"demo"}},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../../assets/img/feeder_2x.gif"),"alt":"feeder"}})])])
}]

export { render, staticRenderFns }